<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Kirim Balik</h5>
            </template>
            <div class="d-flex search-wrapper align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex align-items-center search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.filterNoFaktur" name="filterNoFaktur"
                            type="search"
                            placeholder="Masukkan no. faktur"
                        ></b-form-input>
                        <b-form-select class="mr-2" v-model="input.filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="danger" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <div class="mb-3">
                    <b-button variant="pgiBtn" @click="$bvModal.show('m-create')">Request Kirim Balik Baru</b-button>
                </div>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="dataKirimBalik" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada permintaan kirim balik.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <div>{{row.item.noFaktur}}</div>
                    <div class="smallText text-muted">{{(row.item.lokasi != null) ?row.item.lokasi :"-" }}</div>
                </template>
                <template v-slot:cell(diajukanOleh)="row">
                    <div>{{row.item.createdBy}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormat(row.item.createdAt)}} {{$helper.changeDateFormatGetHour(row.item.createdAt)}}</div>
                </template>
                <template v-slot:cell(barang)="row">
                    <div>
                        <p class="mb-0">{{row.item.jenis}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="dark" v-if="row.item.status == 'DIAJUKAN'">DIAJUKAN</b-badge>
                    <b-badge variant="primary" v-else-if="row.item.status == 'PENGIRIMAN'">PENGIRIMAN</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">DITERIMA</b-badge>
                    <b-badge variant="danger" v-else>DITOLAK</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button v-if="row.item.status != 'DIAJUKAN'" size="sm" variant="primary" v-b-tooltip.hover.top title="Info" @click="lihatKeterangan(row.item)">
                            <i class="fa fa-fw fa-info"></i>
                        </b-button>
                        <b-button v-if="row.item.status == 'PENGIRIMAN'" size="sm" class="ml-2" v-b-tooltip.hover.top title="Terima" variant="success" @click="openModalConfirmTerima(row.item.id)">
                            <i class="fa fa-fw fa-check"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DIAJUKAN</h6>
                <p class="smallText mb-0">Pengajuan menunggu tindak lanjut dari pihak Sinar Mutiara.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENGIRIMAN</h6>
                <p class="smallText mb-0">Barang lelangan sudah diproses oleh Sinar Mutiara, dan sedang dalam pengiriman kembali ke pusat / cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Barang lelangan sudah sampai di pusat / cabang. Status gadai dipulihkan kembali menjadi BERJALAN.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">DITOLAK</h6>
                <p class="smallText mb-0">Pengajuan ditolak oleh Sinar Mutiara.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="m-create" title="Request Kirim Balik Baru" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Mengajukan request kirim balik baru.
            <b-form-group label="No. Faktur" class="mt-4">
                <b-input v-model="create.noFaktur" maxlength="50" />
            </b-form-group>
            <b-form-group label="Catatan">
                <b-form-select name="catatan" v-model="create.notes" :options="catatanDropdown" @keydown.enter="confirmRequestKirimBalik">
                </b-form-select>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="pgiBtn" @click="confirmRequestKirimBalik">
                    Ajukan Kirim Balik
                </b-button>
            </div>
        </b-modal>
        <ModalConfirm id="modal-confirm-reqKirimBalik" title="Konfirmasi Request Kirim Balik" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk request kirim balik faktur ini?" @submit="execRequestKirimBalik()" />
        <b-modal id="modal-confirm-tolak" @shown="focusRejectModal" title="Konfirmasi Tolak Kirim Balik" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting">
            <b-form id="tolakKirimBalikForm" @submit.prevent="tolakKirimBalik">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Keterangan" class="mb-0">
                        <b-form-input ref="keteranganTolakKirimBalik"
                        v-model="input.keteranganTolakKirimBalik"
                        name="keteranganTolakKirimBalik"
                        type="text"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelTolakKirimBalikBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeTolakKirimBalikBtn" :disabled="isSubmitting" type="submit" form="tolakKirimBalikForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="modal-confirm-terima" title="Konfirmasi Terima Kirim Balik" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menerima kirim balik barang ini?" @submit="terimaKirimBalik()" />
        <b-modal id="modal-lihat-keterangan" title="Keterangan Kirim Balik" hide-footer>
            <strong>Diproses Sinar Mutiara pada</strong><br />
            {{ $helper.changeDateFormat(activeItem.processedAt) }}, {{ $helper.changeDateFormatGetHour(activeItem.processedAt) }}
            <div class="mt-4" v-if="activeItem.keterangan != null">
                <strong>Alasan Penolakan</strong><br />
                {{ activeItem.keterangan }}
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'kirim-balik',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            create: {
                noFaktur: "",
                notes: "Barang sudah di SM"
            },

            input:{
                show: 10,
                filterNoFaktur: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null,

                keteranganTolakKirimBalik: ""
            },
            fields: [
                { key: "noFaktur", label: "No Faktur" },
                { key: "diajukanOleh", label: "Diajukan oleh / pada" },
                { key: "barang", label: "Barang" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [
                { id: 0, name: 'Diajukan' },
                { id: 1, name: 'Pengiriman' },
                { id: 2, name: 'Diterima' },
                { id: 3, name: 'Ditolak' },
            ],
            
            // dropdown catatan kirim balik
            catatanDropdown: [
                {value: "Barang sudah di SM", text: "Barang sudah di SM"}, 
                {value: "Barang masih di cabang", text: "Barang masih di cabang"}
            ],
            
             // filterCabang: null,
            dataKirimBalik: [],
            cabangId: '',
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
            idActiveAction: null,

            activeItem: {}

        }
    }, 
    methods: {

        focusRejectModal(){
            this.$refs.keteranganTolakKirimBalik.focus()
        },
        
        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            
            let getDataKirimBalik = this.$axios.get("lelang-kirim-balik/"+this.query).then(response => {
                this.dataKirimBalik = response.data.data
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            Promise.all([getDataKirimBalik]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        openModalConfirmTerima(id) {
            this.idActiveAction = id
            this.$bvModal.show("modal-confirm-terima")
        },

        terimaKirimBalik() {

            let id = this.idActiveAction
            this.isSubmitting = true
            
            this.$axios.post(`lelang-kirim-balik/terima/?id=${id}`).then(() => {

                this.$helper.toastSucc(this, "Berhasil menerima kembali!")
                this.$bvModal.hide("modal-confirm-terima")
                this.getDataKirimBalik()

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        lihatKeterangan(item) {
            this.activeItem = item
            this.$bvModal.show("modal-lihat-keterangan")
        },
        
        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        getDataKirimBalik() {

            this.toggleBusy()
            this.dataKirimBalik = []

            if (!this.$helper.isNullOrEmpty(this.input.filterNoFaktur)) 
                this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur

            if (this.input.filterStatus != null) 
                this.query = this.query + "&filterStatus=" + this.input.filterStatus

            if (this.input.sortBy != null) 
                this.query = this.query + "&sortBy=" + this.input.sortBy

            if (this.input.sortDesc != null) 
                this.query = this.query + "&sortDesc=" + this.input.sortDesc
            
            this.$axios.get("lelang-kirim-balik/" + this.query).then(response => {
                this.dataKirimBalik = response.data.data
                this.updateTotalItem(response.data.total)
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(()=>{
                this.toggleBusy()
                this.loading = false
            })

        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.query = this.query+"&cabangId="+this.cabangId
            this.getDataKirimBalik()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.query = this.query+"&cabangId="+this.cabangId
                this.getDataKirimBalik()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.query = this.query+"&cabangId="+this.cabangId
            this.loading = true
            this.getDataKirimBalik()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDataKirimBalik()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        confirmRequestKirimBalik() {

            if(this.$helper.isNullOrEmpty(this.create.noFaktur)) {
                return this.$helper.toastErr(this, "Mohon mengisi nomor faktur!")
            }

            if(this.$helper.isNullOrEmpty(this.create.notes)) {
                return this.$helper.toastErr(this, "Mohon mengisi catatan!")
            }

            this.$bvModal.show("modal-confirm-reqKirimBalik")

        },

        execRequestKirimBalik() {

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("noFaktur", this.create.noFaktur)
            payload.append("notes", this.create.notes)
            
            this.$axios.post(`lelang-kirim-balik/request-balik-sm`, payload).then(res => {

                this.$helper.toastSucc(this, "Request kirim balik berhasil diajukan, lokasi barang: " + res.data.name)
                this.getDataKirimBalik()

                this.$bvModal.hide("modal-confirm-reqKirimBalik")
                this.$bvModal.hide("m-create")
                this.create.noFaktur = ""
                this.create.notes = ""

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.toggleBusy()
            })

        },

    },

    created(){
        this.init()
    }
}
</script>
